import "./index.less";
import * as React from "react";
import { AtButton } from "@atman/design-system";
import { DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { inject, observer } from "mobx-react";

export type AtMenuButtonBorderType = "hidden" | "hover" | "always";

// Variants
export * from "./components/AtDownChevronMenuButton";

export interface IAtMenuButtonProps {
    size?: "md" | "lg";
    borderType?: AtMenuButtonBorderType;
    customButtonContent?: React.ReactNode;
    disabled?: boolean;
    id?: string;
    className?: string;
}

@inject()
@observer
export class AtMenuButton extends React.Component<IAtMenuButtonProps, {}> {
    render() {
        const {
            children,
            className,
            id,
            size = "lg",
            borderType = "always",
            customButtonContent,
            disabled,
        } = this.props;

        return (
            <UncontrolledDropdown
                id={id}
                direction={"down"}
                className={`AtMenuButton ${className ?? ""} size-${size} border-type-${borderType}`}
            >
                <DropdownToggle tag={"span"} disabled={disabled}>
                    <AtButton
                        disabled={disabled}
                        color={"secondary"}
                        size={size}
                        icon={!customButtonContent ? ["far", "ellipsis-h"] : undefined}
                    >
                        {customButtonContent}
                    </AtButton>
                </DropdownToggle>
                <DropdownMenu>{children}</DropdownMenu>
            </UncontrolledDropdown>
        );
    }
}
